import ModalOptionHandler from './handler_options_modal.js';

(function ( $ ) {
  $.fn.dynamicOption = function(options) {
    let select = this,
      isMultiple = select[0].multiple,
      $select = select.get(0),
      $selectContainer = select.siblings('span.select2-container').get(0),
      $editButton = !!select.siblings('button.btn-link').length ?
        select.siblings('button.btn-link').get(0) :
        $('<button type="button" class="btn btn-link btn-sm btn-dynamic-option-edit py-0">Editar</button>').get(0);

    $(this).select2({ language: "pt-BR", closeOnSelect: true, placeholder: '-- selecione --' });

    options = {
      text: '+ Novo Item',
      modalLabelName: 'Nome do Item',
      saveItem: () => {},
      ...options
    };

    toggleButton();

    if (!isMultiple) {
      $($select).after($editButton);
      $($editButton).on('click', (ev) => onClickEdit(ev));
    }
    select.on('select2:select', () => toggleButton());
    select.on('select2:open', () => {
      let dropdownSpan = select.data('select2').$results.parents('.select2-results');
      if (!!$(dropdownSpan).find('div.select2-link').length) return;
      let $newItemLink = $(`<div class="select2-link"><a>${options.text}</a></div>`).get(0);
      dropdownSpan.append($newItemLink).on('click', (ev) => onClickNew(ev));
    });

    function toggleButton() {
      let selectedOption = !!select.select2('data')[0] && !!select.select2('data')[0].id;

      if (!!isMultiple)
        return;

      $editButton.classList.toggle('fade', !selectedOption);
      $editButton.style.zIndex = !selectedOption ? -1 : +$selectContainer.style.zIndex + 1;
    }

    function onClickEdit(ev) {
      ev.stopPropagation();
      let data = select.select2('data')[0];
      options.modalTitle = 'Editar Item';
      options.editable = data.text;
      options.itemId = data.id;
      ModalOptionHandler.openModal(select, options);
    }

    function onClickNew(ev) {
      ev.stopPropagation();
      select.data('select2').trigger('close'),
      options.modalTitle = 'Novo Item',
      options.editable = '',
      options.itemId = '';
      ModalOptionHandler.openModal(select, options);
    }

    return select;
  };
}( jQuery ));